import type * as React from 'react'
import type { EarnedItemStaticProperties } from './EarnedItem.types'
import EarnedItemPoint from './EarnedItemPoint'
import EarnedItemScheduled from './EarnedItemScheduled'

const EarnedItem: React.FC & EarnedItemStaticProperties = () => {
    return null
}

EarnedItem.Point = EarnedItemPoint
EarnedItem.Scheduled = EarnedItemScheduled

export default EarnedItem
